import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDataService } from '../user-data/user-data.service';

@Injectable()
export class AuthGuard implements CanActivateChild {
  constructor(private _userDataService: UserDataService,
    private router: Router) {
  } // CONSTRUCTOR

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this._userDataService.isSetupComplete()) {
      return true;
    } else {
      this.router.navigate(['/user-setup']);
      return false;
    }
  } // CAN-ACTIVATE-CHILD

} // EXPORT
